import * as React from 'react';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import { useWindowSize } from 'rooks';
import { LargeMonitorContext } from '../context';

import Body from './common/Body';
import 'semantic-ui-css/semantic.min.css';
import '../assets/scss/index.scss';
import { mediaStyle } from '../helpers/responsive';

const Layout = ({ children, hideFooter = false }) => {
  const [largeMonitor, setLargeMonitor] = useState(false);
  const { innerWidth } = useWindowSize();

  useEffect(() => {
    setLargeMonitor(innerWidth > 1023);
  }, [innerWidth]);

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <React.Fragment>
      <Helmet title={data.site.siteMetadata.title}>
        <html lang="en" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0" />
        <style>{mediaStyle}</style>
      </Helmet>
      <LargeMonitorContext.Provider value={largeMonitor}>
        <Body hideFooter={hideFooter}>{children}</Body>
      </LargeMonitorContext.Provider>
    </React.Fragment>
  );
};

export default Layout;
